import React from 'react'; // TODO

var FormContext = /*#__PURE__*/React.createContext({
  controlId: undefined
});
export default FormContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/esm/FormContext.js
// module id = 16
// module chunks = 17